import React from "react";
import Box from "../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../services/Notify";
import Loading from "../component/Loading/Loading";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector";
import StockLevelService from "./StockLevelService";
import ProductTypeSelector from "../productType/component/ProductTypeSelector";
import FormButtons from "../component/Form/FormButtons";
import DispositionSelector from "../disposition/DispositionSelector";
import {InputWithLabel} from "../component/Form/InputWithLabel";

class StockLevelForm extends React.Component {

  service = new StockLevelService();

  constructor(props) {
    super(props);
    this.state = {
      quantityMin: null,
      quantitySecure: null,
      quantityMax: null
    };
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      this.setState({loading: true});
      this.service.findById(id).then(
        data => {
          data.productType.referenceOrFriendlyName = `${data.productType.reference} - ${data.productType.friendlyName}`;
          this.setState(
            {
              loading: false,
              entity: data,
              quantitySecure: data.quantitySecure ? data.quantitySecure : 0
            });
        },
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
      )
    }
  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity && this.state.entity.version;

    if (existingEntity) {
      if (!this.bizLocationId) {
        this.bizLocationId = this.state.entity ? this.state.entity.bizLocation.id : null;
      }
      if (!this.productTypeId) {
        this.productTypeId = this.state.entity ? this.state.entity.productType.id : null;
      }
    }
    const entity = {
      id: existingEntity,
      dispositions: this.dispositions && this.dispositions.map(x => ({id: x.id})),
      bizLocation: {id: this.bizLocationId},
      productType: {id: this.productTypeId},
      quantityMin: this.state.quantityMin,
      quantityMax: this.state.quantityMax,
      quantitySecure: this.state.quantitySecure,
    };
    if (entityVersion >= 0) {
      entity.version = entityVersion;
    }
    this.setState({loading: true, message: 'Salvando...'});
    this.service.save(entity).then(
      () => {
        this.props.history.goBack();
        Notify.success('Entidade salva');
      },
      (error) => {
        Notify.error('Falha ao salvar entidade:', error);
        this.setState({loading: false, message: null});
      }
    );
  }

  textOnlyNumbers(text) {
    if (!text) {
      return null
    }
    return text.toString().replace(/\D/, '')
  }

  render() {
    const {loading, entity, message, quantityMax, quantityMin, quantitySecure} = this.state;

    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }
    return (

      <Box info>
        <form ref={form => (this.form = form)} onSubmit={event => {
          event.preventDefault();
          this.submitForm()
        }}>

          <BizLocationSelector required={true}
            defaultValue={entity && entity.bizLocation}
            onChange={bizLocationId => {
              this.bizLocationId = bizLocationId && bizLocationId.id;
            }}/>

          <ProductTypeSelector required={true}
            active={true}
            defaultValue={entity && entity.productType}
            onChange={productTypeId => {
              this.productTypeId = productTypeId && productTypeId.id;
            }}/>

          <DispositionSelector required={false}
            multiple={true}
            defaultValue={entity && entity.dispositions}
            setValue={disposition => this.dispositions = disposition}/>

          <InputWithLabel
            inputType="number"
            label="Nível Mínimo: (Vermelho)"
            required
            min={1}
            max={quantitySecure}
            defaultValue={entity && entity.quantityMin}
            value={quantityMin}
            onChangeText={text => {
              this.setState({
                quantityMin: this.textOnlyNumbers(text)
              })
            }}
          />

          <InputWithLabel
            inputType="number"
            label="Nível de Segurança: (Amarelo)"
            required
            min={quantityMin}
            max={quantityMax}
            defaultValue={entity && entity.quantitySecure}
            value={quantitySecure}
            onChangeText={text => {
              this.setState({
                quantitySecure: this.textOnlyNumbers(text)
              })
            }}
          />

          <InputWithLabel
            inputType="number"
            label="Nível Máxima: (Verde)"
            required
            min={quantitySecure}
            defaultValue={entity && entity.quantityMax}
            value={quantityMax}
            onChangeText={text => {
              this.setState({
                quantityMax: this.textOnlyNumbers(text)
              })
            }}
          />

          <FormButtons history={this.props.history} />
        </form>
      </Box>);
  }

  filterItems(item) {
    const {entity} = this.state;
    return item.id !== entity.id;
  }
}

StockLevelForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default StockLevelForm;



// WEBPACK FOOTER //
// ./src/stockLevel/StockLevelForm.js